import networkService from '../../Network/NetworkManager';
import {uuid} from 'uuidv4';
import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';

export const deleteUser = async ({id, setIsLoading, fetchUsers}) => {
  try {
    setIsLoading(true);
    const responseJson = await networkService.networkCall(
      `/v1/users/${id}`,
      'delete',
      JSON.stringify({
        user: {},
      }),
    );
    setIsLoading(false);
    ToastPopup({type: 'success', message: 'User deleted successfully'});
    fetchUsers();
  } catch (error) {
    setIsLoading(false);
    ToastPopup({type: 'error', message: 'User deletion failed'});
  }
};
